import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { AdminService } from '../../services/admin.service';
import { MasterDTO } from '../../model/admin.entity';
import { CommonService } from '../../../core/common/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { MasterDataRepository } from '../../../core/data/repositories/masterdata.repository';

@Component({
  selector: 'tandc-glass-coating-code',
  templateUrl: './glass-coating-code.component.html',

})
export class GlassCoatingCodeComponent implements OnInit {

  glassCoatingList: MasterDTO[] = [];
  glassCoating: MasterDTO = new MasterDTO();
  showModal: boolean = false;
  modalTitle: string = "";
  @ViewChild('dt')
  dt!: Table;

  constructor(private service: AdminService,
    private commonService: CommonService,
    private translate: TranslateService,
    private masterDataRepository: MasterDataRepository) { }

  ngOnInit(): void {
    this.getAll();
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.dt!.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  getAll() {
    this.service.getGlassCoatingCode().subscribe((x) => {
      this.glassCoatingList = x.value;
    })
  }

  addModal() {
    this.glassCoating = new MasterDTO();
    this.showModal = !this.showModal;
    this.modalTitle =
      this.translate.instant('commonbtn.add') +
      ' ' +
      this.translate.instant('Master.glassCoatingCode');
  }


  save(data: MasterDTO) {
    if (data.id > 0) {
      this.service.updateGlassCoatingCode(data).subscribe((res) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.UpdatedSuccessfully')
          );
          this.getAll();
        }
      });
    } else {
      this.service.saveGlassCoatingCode(data).subscribe((res) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.SavedSuccessfully')
          );
          this.getAll();
        }
      });
    }
  }

  deleteCoating(data: MasterDTO) {
    this.commonService.confirmationService.confirm({
      message: this.translate.instant('Alerts.DeleteConfirmation'),
      accept: () => {
        if (data) {
          this.service.deleteGlassCoatingCode(data.id).subscribe((res) => {
            if (res) {
              this.commonService.successMessage(
                this.translate.instant('Alerts.DeleteSuccessfully')
              );
              this.getAll();
            }
          });
        }
      },
    });
  }

  onToggleStatus(item: MasterDTO) {
  const updatedItem = { ...item }; 
  this.service.updateGlassCoatingCode(updatedItem).subscribe({
    next: () => {
      this.commonService.successMessage(
        this.translate.instant('Alerts.UpdatedSuccessfully')
      );
    },
    error: () => {
      this.commonService.errorMessage(
        this.translate.instant('Alerts.ErrorOccured')
      );
      // Revert toggle on error
      item.isActive = !item.isActive;
    }
  });
  }

  edit(data: MasterDTO) {
    this.modalTitle = this.translate.instant('common.update') + ' ' + this.translate.instant('Master.glassCoatingCode');
    this.glassCoating = data;
    this.showModal = !this.showModal;
  }

  downloadFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  export() {
    this.masterDataRepository.export('glass-coating').subscribe(blob => {
      this.downloadFile(blob, `glass-coating-${new Date().toISOString().slice(0,10)}.xlsx`);
    });
  }

}
